import { KustomerCoreWindow } from 'core/types';
import { ApiKey } from 'globals/types';
import { getApiEnv } from 'core_main/globals/api';

interface TokenPayload {
  id: string;
  org: string;
  orgName: string;
  user?: string;
  pod?: string;
}

const getApiKey = () => {
  const kustomerCoreWindow: KustomerCoreWindow = window.parent;
  return kustomerCoreWindow.KustomerCore?.a;
};

const validateApiKey = (tokenPayload: TokenPayload): void => {
  const requiredKeys = ['orgName'];
  if (
    !requiredKeys.every((key) => {
      return key in tokenPayload;
    })
  ) {
    console.error("You've provided an invalid Kustomer api key.");
  }
};

export const parseApiKey = (apiKey?: ApiKey) => {
  try {
    if (!apiKey) throw new Error();

    const [_, payload] = apiKey.split('.');

    const tokenPayload: TokenPayload = JSON.parse(atob(payload));
    validateApiKey(tokenPayload);
    return tokenPayload;
  } catch (error) {
    console.error("You've provided an invalid Kustomer api key.");
    return {} as TokenPayload;
  }
};

const { orgName, pod } = parseApiKey(getApiKey());

export const getEnv = () => ({
  pod,
  orgName,
  ...getApiEnv(),
});
